import { takeLatest, call, put } from 'redux-saga/effects'
import I18n from 'i18n'

import UploadFile from 'api/commons/UploadFile'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import { ActionWithPayload } from 'helpers/redux-actions.helper'
import * as fromActions from '../../actions/monitoring.actions'

const monitoringUpload = (id: number, file: File) => {
  return UploadFile(file, `/monitoring/${id}/imports`)
}

const pattern = fromActions.USER_MONITORING_UPLOAD

function* monitoringUploadEffectSaga(
  action: ActionWithPayload<typeof pattern, fromActions.UploadFilePayload>
) {
  try {
    const { file, id, onSuccess } = action.payload
    const { data } = yield call(monitoringUpload, id, file)
    // dispatch action to change redux state
    yield put(fromActions.Actions.uploadFileSuccess(data))

    const estimatedTime = 5000
    setTimeout(() => {
      onSuccess?.()
    }, estimatedTime)
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.deleteError'))
    console.log('error: ', error)
  }
}

export function* monitoringUploadWatcherSaga() {
  yield takeLatest(
    fromActions.USER_MONITORING_UPLOAD,
    monitoringUploadEffectSaga
  )
}
